<template>
  <section v-if="resolvedItems.length" :id="sectionId" class="entity-section">
    <v-container>
      <p class="section-kicker">{{ kicker }}</p>
      <h2>{{ title }}</h2>
      <p v-if="description" class="section-description">{{ description }}</p>
      <div class="entity-grid">
        <EntityCard
          v-for="item in resolvedItems"
          :key="`${item.reference.entityId}-${item.reference.order || 0}`"
          :entity="item.entity"
          :reference="item.reference"
          :detail-route="item.detailRoute"
        />
      </div>
    </v-container>
  </section>
</template>

<script>
import { sortEventEntities } from '../../../data/reckon-way/sortEventEntities';
import EntityCard from './EntityCard.vue';
import { eventEntityRoute, resolveEventEntityDetails } from '../../../lib/reckon-way/entityDetails';

export default {
  name: 'EntitySection',
  components: { EntityCard },
  props: {
    items: { type: Array, default: () => [] },
    entityById: { type: Object, required: true },
    title: { type: String, required: true },
    kicker: { type: String, default: 'Along the Way' },
    description: { type: String, default: '' },
    sectionId: { type: String, required: true },
    event: { type: Object, default: null },
    detailEnabled: { type: Boolean, default: false },
  },
  computed: {
    resolvedItems() {
      return sortEventEntities(this.items, this.entityById)
        .map((reference) => {
          const entity = this.entityById[reference.entityId];
          const details = this.detailEnabled
            ? resolveEventEntityDetails({
              event: this.event, sectionKey: this.sectionId, item: reference, entity,
            })
            : null;
          return {
            reference,
            entity,
            detailRoute: details?.media.length ? eventEntityRoute(this.event, this.sectionId, reference) : null,
          };
        })
        .filter((item) => item.entity);
    },
  },
};
</script>

<style scoped>
.entity-section { background: #080808; border-top: 1px solid #232323; padding: 72px 0; scroll-margin-top: 68px; }
.entity-section:nth-of-type(even) { background: #0d0d0d; }
.section-kicker { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; letter-spacing: 0.1em; margin: 0 0 8px; text-transform: uppercase; }
h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: clamp(2rem, 5vw, 3.2rem); line-height: 1; margin: 0; }
.section-description { color: #aaa; line-height: 1.6; margin: 16px 0 0; max-width: 760px; }
.entity-grid { display: grid; gap: 18px; grid-template-columns: repeat(2, minmax(0, 1fr)); margin-top: 30px; }
@media (max-width: 760px) { .entity-grid { grid-template-columns: 1fr; } }
</style>
